import React from "react";

function CustomButton({ text, onClick, icon }) {
  return (
    <button
      className="poppins-medium flex items-center justify-center bg-[#BE202F] hover:bg-[#D35B66] text-white text-xs py-4 px-4 rounded-2xl tracking-wider"
      onClick={onClick}
    >
      {icon && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          className="w-5 h-5 mr-1"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 4.5v15m7.5-7.5h-15"
          />
        </svg>
      )}
      {text}
    </button>
  );
}

export default CustomButton;
